import { CustomUser } from '@/models/custom-user.model';
import { GetterTree } from 'vuex';
import { AuthenticationState } from './types';
import { RootState } from '../types';

const testForUserHasPermission = (user: CustomUser | undefined, permissionToTest: string) => {
    if (!user || !permissionToTest || !permissionToTest.length) {
        console.error('hasPermission::failed – missing parameters');
        return false;
    }
    return !!user.permissions.find((permission) => permission.label === permissionToTest);
};

export const getters: GetterTree<AuthenticationState, RootState> = {
    isAuthenticated: (state: AuthenticationState): boolean => {
        return !!state.user;
    },
    userToken: (state: AuthenticationState): string => {
        return !!state.user ? state.user.token : '';
    },
    hasPermission: (state: AuthenticationState) => (permissionToTest: string): boolean => {
        return state.user && testForUserHasPermission(state.user, permissionToTest) || false;
    },
    hasSomePermission: (state: AuthenticationState) => (permissionsToTest: string[]): boolean => {
        return state.user && permissionsToTest.some((permissionToTest: string) => {
            return testForUserHasPermission(state.user, permissionToTest);
        }) || false;
    },
    hasEveryPermission: (state: AuthenticationState) => (permissionsToTest: string[]): boolean => {
        return state.user && permissionsToTest.every((permissionToTest: string) => {
            return testForUserHasPermission(state.user, permissionToTest);
        }) || false;
    },
};
